'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIToggle from 'UIComponents/input/UIToggle';
import { getExtraJsonForAction } from 'DesignComponents/utils/usageTracker/eventUtils';
import EnableEmailRenderingV3Modal from 'DesignEditorsUI/components/modals/EnableEmailRenderingV3Modal';
import EmailV3FeedbackLoader from 'DesignEditorsUI/components/shared/EmailV3FeedbackLoader';
import EmailV3RenderingPopover from 'DesignEditorsUI/components/shared/controls/EmailV3RenderingPopover';
import { usageTrackerActions } from 'usage-tracker-redux';
const {
  track
} = usageTrackerActions;

class IsEnabledForEmailV3RenderingToggle extends PureComponent {
  constructor(props) {
    super(props);

    this.onClickToggle = () => {
      this.setState({
        modalOpen: true
      });
    };

    this.state = {
      modalOpen: false
    };
  }

  renderConfirmModal() {
    if (!this.state.modalOpen) return null;
    return /*#__PURE__*/_jsx(EnableEmailRenderingV3Modal, {
      onConfirm: () => {
        this.props.track('programmableEmailInteraction', getExtraJsonForAction(!this.props.checked ? 'enable' : 'disable'));
        this.props.onChange(!this.props.checked);
        this.setState({
          modalOpen: false
        });
      },
      onCancel: () => {
        this.setState({
          modalOpen: false
        });
      },
      version: this.props.checked ? 'MODULE_TWO' : 'MODULE_THREE',
      fileId: this.props.fileId
    });
  }

  render() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: "display-flex align-center m-bottom-2",
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: this.props.toggleLabel
        }), /*#__PURE__*/_jsx(UIToggle, {
          disabled: this.props.disabled,
          checked: this.props.checked,
          onChange: this.onClickToggle,
          size: "extra-small"
        })]
      }), this.props.tooltipTitle, /*#__PURE__*/_jsx("div", {
        className: "m-top-2",
        children: /*#__PURE__*/_jsx(EmailV3RenderingPopover, {})
      }), this.props.checked && /*#__PURE__*/_jsx(EmailV3FeedbackLoader, {}), this.renderConfirmModal()]
    });
  }

}

IsEnabledForEmailV3RenderingToggle.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  toggleLabel: PropTypes.node.isRequired,
  tooltipTitle: PropTypes.node,
  fileId: PropTypes.number.isRequired,
  track: PropTypes.func.isRequired
};
IsEnabledForEmailV3RenderingToggle.defaultProps = {
  disabled: false
};
export default connect(null, {
  track
})(IsEnabledForEmailV3RenderingToggle);